import { useAgentRuntime, useAgentStore } from '@/context/AgentProvider'
import { IconButton } from '@/components/ui/IconButton'
import { useTranslations } from '@/hooks/useTranslations'

interface AgentControlsProps {
  onClose?: () => void
  agentLogo?: React.ReactElement
}

const AgentControls = ({ onClose, agentLogo }: AgentControlsProps) => {
  const t = useTranslations()
  const runtime = useAgentRuntime()
  const showHistory = runtime.config.features?.historySidebar !== false
  const isChatHistoryOpen = useAgentStore((state) => state.isChatHistoryOpen)
  const setChatHistoryOpen = useAgentStore((state) => state.setChatHistoryOpen)
  const setActiveChat = useAgentStore((state) => state.setActiveChat)

  const handleNewChat = () => {
    setActiveChat(undefined)
  }

  return (
    <div className='mp-agent-agent-controls'>
      <div className='mp-agent-agent-controls-left'>
        {showHistory && (
          <IconButton
            onClick={() => setChatHistoryOpen(!isChatHistoryOpen)}
            icon={isChatHistoryOpen ? 'PanelLeftClose' : 'PanelLeftOpen'}
            tooltip={isChatHistoryOpen ? t.hideChatHistory : t.showChatHistory}
            aria-label={isChatHistoryOpen ? t.hideChatHistory : t.showChatHistory}
          />
        )}
        <IconButton onClick={handleNewChat} icon='SquarePen' aria-label={t.newChat} tooltip={t.newChat} />
      </div>
      {agentLogo && <div className='mp-agent-agent-controls-logo'>{agentLogo}</div>}
      {t.panelTitle && (
        <div className='mp-agent-agent-controls-title'>
          <h4>{t.panelTitle}</h4>
        </div>
      )}
      {onClose && (
        <div className='mp-agent-agent-controls-right'>
          <IconButton onClick={onClose} icon='X' aria-label={t.close} tooltip={t.close} />
        </div>
      )}
    </div>
  )
}

export default AgentControls
